import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { formatSubscriberCount } from "../../../utils/k&mConvertor";
import { Spinner } from "react-bootstrap";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useEffect, useState } from "react";

export default function InfoCard({ label, icon, bg, loading, name, ownerId }) {
  const splitLabel = label.split(" ");
  const firstItem = splitLabel[0];
  const history = useHistory();
  const [disable, setDisable] = useState(false);

  let secondItem;
  if (splitLabel.length > 2) {
    secondItem = splitLabel.slice(1).join(" ");
  } else {
    secondItem = splitLabel[1];
  }

  const classes = `card text-white bg-${bg} o-hidden h-100 border-none`;

  const handleDetails = () => {
    if (name === "channel") {
      const element = document.getElementById("myChannels");
      if (element) {
        const elementPosition =
          element.getBoundingClientRect().top + window.scrollY;
        const offset = 65;
        window.scrollTo({
          top: elementPosition - offset,
          behavior: "smooth",
        });
      }
    }

    if (name === "video") {
      history.push(`/allMyVideos/${ownerId}?admin=false`);
    }

    if (name === "comment") {
      history.push(`/comment-statistics`);
    }

    if (name === "interaction") {
      history.push(`/interaction-statistics`);
    }

    if (name === "view") {
      history.push(`/view-statistics`);
    }
  };

  return (
    <>
      <div
        className="mb-2"
        style={{
          flexGrow: "1",
        }}
      >
        <div className={classes}>
          <div className="card-body">
            <div className="card-body-icon">
              <FontAwesomeIcon icon={icon} fixedWidth />
            </div>
            <div className="mr-5 cardTitle">
              {loading ? (
                <Spinner size="sm" animation="border" role="status" />
              ) : (
                <>
                  <b>{formatSubscriberCount(firstItem)}</b> {secondItem}
                </>
              )}
            </div>
          </div>
          <div
            title={disable && "به زودی فعال میشود."}
            style={{ cursor: disable ? "not-allowed" : "pointer" }}
            className="card-footer text-white clearfix small z-1"
            onClick={handleDetails}
          >
            <span className="float-left">نمایش جزئیات</span>
            <span className="float-right">
              <FontAwesomeIcon icon={faAngleRight} />
            </span>
          </div>
        </div>
      </div>
    </>
  );
}
